'use strict';

/**
 * newsList
 */
$.fn.pagination = function(config) {
  var o = $.extend(
    {
      pager: $('.pager'),
      prevText: '',
      nextText: '',
      firstText: 'first',
      lastText: 'last',
      ellipsisText: '...',
      viewNum: 8,
      pagerNum: 3,
      ellipsis: true,
      linkInvalid: false,
      goTop: true,
      firstLastNav: true,
      prevNextNav: true,
    },
    config
  );

  var $element = $(this);
  var $pager = o.pager;
  if (o.ellipsis) {
    var $ellipsisFirst = $('<span class="ellipsis"/>').text(o.ellipsisText);
    var $ellipsisLast = $('<span class="ellipsis"/>').text(o.ellipsisText);
  }

  var tatalItemNum = $element.length;
  var tatalpageNum = Math.ceil(tatalItemNum / o.viewNum);
  var ellipsisFlag = false;

  var currentIndex = 0;

  if (tatalpageNum > o.pagerNum) {
    ellipsisFlag = true;
  }

  for (var i = 0; i < tatalpageNum; i++) {
    $('<span class="c-pager_num" />')
      .text(i + 1)
      .appendTo($pager);
  }
  if (o.firstLastNav) {
    $('<span class="c-pager_prev js-prev"/>')
      .text(o.prevText)
      .prependTo($pager);
    $('<span class="c-pager_next js-next"/>')
      .text(o.nextText)
      .appendTo($pager);
  }
  if (o.prevNextNav) {
    $('<span class="c-pager_prev js-first"/>')
      .text(o.firstText)
      .prependTo($pager);
    $('<span class="c-pager_next js-last"/>')
      .text(o.lastText)
      .appendTo($pager);
  }
  var $pagerInner = $pager.find('span').not('.js-prev, .js-next, .js-first, .js-last');

  $element.hide();
  for (var i = 0; i < o.viewNum; i++) {
    $($element[i]).show();
  }

  $pagerInner.hide();
  for (var i = 0; i < o.pagerNum; i++) {
    $($pagerInner[i]).show();
  }
  $($pagerInner[0]).addClass('current');
  if (o.linkInvalid) {
    $('.js-prev').addClass('disabled');
    $('.js-first').addClass('disabled');
  }
  if (o.ellipsis) {
    if (ellipsisFlag) {
      if (tatalpageNum - o.pagerNum > 1) {
        $($pagerInner[tatalpageNum - 1]).before(function() {
          return $ellipsisLast;
        });
      }
      $($pagerInner[tatalpageNum - 1]).show();
    }
  }

  $('.js-first').on('click', function() {
    var current = 0;
    if (currentIndex == 0) {
      if (o.linkInvalid) {
        return false;
      }
    }
    change(current);
  });

  $('.js-last').on('click', function() {
    var current = tatalpageNum - 1;
    if (currentIndex == $pagerInner.length - 1) {
      if (o.linkInvalid) {
        return false;
      }
    }
    change(current);
  });

  $('.js-prev').on('click', function() {
    var current = currentIndex - 1;
    if (currentIndex == 0) {
      if (o.linkInvalid) {
        return false;
      } else {
        current = currentIndex;
      }
    }
    change(current);
  });

  $('.js-next').on('click', function() {
    var current = currentIndex + 1;
    if (currentIndex == $pagerInner.length - 1) {
      if (o.linkInvalid) {
        return false;
      } else {
        current = currentIndex;
      }
    }
    change(current);
  });

  $pagerInner.each(function(current) {
    $(this).on('click', function() {
      if ($(this).hasClass('current')) {
        if (o.linkInvalid) {
          return false;
        }
      }
      change(current);
    });
  });

  var change = function change(current) {
    $element.hide();
    for (var i = current * o.viewNum; i < (current + 1) * o.viewNum; i++) {
      $($element[i]).show();
    }
    $pagerInner.hide();
    if (o.ellipsis) {
      if (ellipsisFlag) {
        $ellipsisFirst.remove();
        $ellipsisLast.remove();
      }
    }
    var num = current - 1;
    if (num > tatalpageNum - o.pagerNum) {
      num = tatalpageNum - o.pagerNum;
    }
    for (var i = num; i < num + o.pagerNum; i++) {
      $($pagerInner[i]).show();
    }
    if (o.ellipsis) {
      if (ellipsisFlag) {
        $($pagerInner[0]).show();
        if (num > 1) {
          $($pagerInner[0]).after(function() {
            return $ellipsisFirst;
          });
        }
        if (num < tatalpageNum - o.pagerNum - 1) {
          $($pagerInner[tatalpageNum - 1]).before(function() {
            return $ellipsisLast;
          });
        }
        $($pagerInner[tatalpageNum - 1]).show();
      }
    }
    currentIndex = current;

    $pagerInner.removeClass('current');
    $($pagerInner[current]).addClass('current');
    if (o.linkInvalid) {
      if (current == 0) {
        $('.js-prev').addClass('disabled');
        $('.js-first').addClass('disabled');
      } else {
        $('.js-prev').removeClass('disabled');
        $('.js-first').removeClass('disabled');
      }
      if (current == tatalpageNum - 1) {
        $('.js-next').addClass('disabled');
        $('.js-last').addClass('disabled');
      } else {
        $('.js-next').removeClass('disabled');
        $('.js-last').removeClass('disabled');
      }
    }
    if (o.goTop) {
      $('html,body').scrollTop(0);
    }
  };
};

if ($('.js-postList').length > 8) {
  $('.js-postList').pagination({
    pager: $('#pager'),
    prevText: '',
    nextText: '',
    firstText: 'first',
    lastText: 'last',
    viewNum: 8,
    pagerNum: 3,
    linkInvalid: true,
    goTop: true,
    firstLastNav: true,
    prevNextNav: false,
    ellipsisText: '...',
  });
} else {
  $('#pager').remove();
}
